import { CoverageGolfCartValue } from "@covertree/new-business-graphql";

export function mapNumberToGolfCartValueEnum(
  value: number
): CoverageGolfCartValue {
  switch (value) {
    case 1:
      return CoverageGolfCartValue.One;
    case 2:
      return CoverageGolfCartValue.Two;
    case 3:
      return CoverageGolfCartValue.Three;
    case 4:
      return CoverageGolfCartValue.Four;
    case 5:
      return CoverageGolfCartValue.Five;
    default:
      throw new Error("Unknown value for CoverageGolfCart");
  }
}
